<template>
  <div class="speed-line">
    <div class="wraper">
      <span class="step-one select">填写联系信息</span>
      <span :class="['step-two', progress >= 2 ? 'select' : '']"
        >填写企业信息</span
      >
      <span :class="progress >= 3 ? 'select' : ''">完成注册</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    progress: {
      type: [Number, String],
      default: 1
    }
  }
}
</script>
<style lang="less" scoped>
.speed-line {
  height: 120px;
  background: #fafafa;
  border: 1px solid #e4e5e6;
  border-radius: 5px;
  margin: 0px 20px 40px;
  text-align: center;
  .wraper {
    display: inline-block;
    margin: 45px auto 0;
    span {
      font-size: 12px;
      color: #a1a9b2;
      line-height: 18px;
      display: block;
      margin-right: 170px;
      float: left;
      position: relative;
      &:before {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: block;
        background: #fafafa;
        -webkit-box-shadow: 0 0 0 4px #e4e5e6;
        box-shadow: 0 0 0 4px #e4e5e6;
        margin: 0 auto 5px;
      }
      &:after {
        position: absolute;
        left: 42px;
        content: '';
        width: 220px;
        top: 4px;
        height: 1px;
        display: block;
        background: #ddd;
      }
      &.step-one {
        &:after {
          width: 230px;
        }
      }
    }

    .select {
      color: #25a6ff;
      &:before {
        background: #25a6ff;
        -webkit-box-shadow: 0 0 0 4px rgba(37, 166, 255, 0.2);
        box-shadow: 0 0 0 4px rgba(37, 166, 255, 0.2);
      }
    }
    span:last-child {
      margin-right: 0;
      &:after {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SpeedLine.vue